export const VALIDATION_PATTERNS = {
  NO_ONLY_WHITESPACE:  /^(?!\s*$).+/
};
